<template>
  <v-layout row justify-center>
    <v-dialog v-model="displayForm" persistent max-width="980px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline" v-if="item">Update Item</span>
            <span class="headline" v-else>Add Item</span>
          </v-card-title>
          <div class="text-xs-center">
            <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
          </div>
          <v-card-text v-if="!loading">
            <v-alert
              :value="messages.length > 0"
              type="error"
              dismissible
              transition="scale-transition"
            >
              <div v-for="message in messages" :key="message">{{ message }}</div>
            </v-alert>

            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <span v-if="item">{{ model.id }}</span>
                  <v-text-field v-else v-model="model.id" label="Id" :rules="mandatoryRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="model.name" label="Name" :rules="mandatoryRules"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="model.price" label="Price" :rules="mandatoryRules"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
            <v-btn
              v-if="item"
              color="blue darken-1"
              text
              @click="update()"
              :disabled="loading"
            >Update</v-btn>
            <v-btn v-else color="blue darken-1" text @click="add()" :disabled="loading">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
function getDefaultData() {
  return {
    model: {
      id: null,
      name: null,
      price: null
    },
    valid: null,
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    messages: []
  };
}
export default {
  props: ["item", "open"],
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
    loading: function() {
      return this.$store.getters["fittingTypes/loading"];
    }
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
    }
  },
  methods: {
    add() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("fittingTypes/add", {
            model: this.model
          })
          .then(() => {
            this.$emit("add");
            this.resetForm();
          })
          .catch(({data}) => {
            this.messages.push(data.message)
            for (const error of Object.entries(data.errors)) {
              this.messages.push(error[1][0])
            }
          })
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("fittingTypes/update", {
            model: this.model
          })
          .then(() => {
            this.$emit("update");
            this.resetForm();
          })
          .catch(({data}) => {
            this.messages.push(data.message)
            for (const error of Object.entries(data.errors)) {
              this.messages.push(error[1][0])
            }
          })
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
